import { html } from 'lit'
import { IconBase } from './icon-base.js'

class Icon extends IconBase {
  render() {
    return html`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        part="svg"
      >
        <path
          d="M4.72727 10.1538C4.72727 10.9185 4.11675 11.5385 3.36364 11.5385C2.61052 11.5385 2 10.9185 2 10.1538C2 9.38914 2.61052 8.76923 3.36364 8.76923C4.11675 8.76923 4.72727 9.38914 4.72727 10.1538Z"
        />
        <path
          d="M11.0909 12C11.0909 12.2549 10.8874 12.4615 10.6364 12.4615C10.3853 12.4615 10.1818 12.2549 10.1818 12C10.1818 11.7451 10.3853 11.5385 10.6364 11.5385C10.8874 11.5385 11.0909 11.7451 11.0909 12Z"
        />
        <path
          d="M10.6364 18C13.8999 18 16.5455 15.3137 16.5455 12L22 10.6154V6H10.6364C7.37286 6 4.72727 8.68629 4.72727 12C4.72727 15.3137 7.37286 18 10.6364 18Z"
        />
      </svg>
    `
  }
}
customElements.define('whistle-icon', Icon)
